import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const Manager = lazy(() => import('../pages/manager/page'));
const NurseDashboard = lazy(() => import('../pages/nurse-dashboard/page'));
const TaskCompletion = lazy(() => import('../pages/task-completion/page'));
const DemoManager = lazy(() => import('../pages/demo-manager/page'));
const DemoNurse = lazy(() => import('../pages/demo-nurse/page'));
const DemoReception = lazy(() => import('../pages/demo-reception/page'));
const EquipmentFault = lazy(() => import('../pages/equipment-fault/page'));
const Login = lazy(() => import('../pages/login/page'));
const BookDemo = lazy(() => import('../pages/book-demo/page'));
const BookACall = lazy(() => import('../pages/book-a-call/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/register',
    element: <Login />,
  },
  {
    path: '/book-demo',
    element: <BookDemo />,
  },
  {
    path: '/book-a-call',
    element: <BookACall />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/manager',
    element: <Manager />,
  },
  {
    path: '/nurse-dashboard',
    element: <NurseDashboard />,
  },
  {
    path: '/task/:taskId',
    element: <TaskCompletion />,
  },
  {
    path: '/task-completion',
    element: <TaskCompletion />,
  },
  {
    path: '/demo-manager',
    element: <DemoManager />,
  },
  {
    path: '/demo-nurse',
    element: <DemoNurse />,
  },
  {
    path: '/demo-reception',
    element: <DemoReception />,
  },
  {
    path: '/equipment-fault',
    element: <EquipmentFault />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;